import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";
import { setLoading } from "./loading";
import ShareholdingService from "../services/shareholding.services";
import { getOshmaById } from "./oshma";

const initialState = {
  shareholding: [],
};

export const setSearch = createAsyncThunk(
  "users/setSearchValue",
  ({ searchValue }, thunkAPI) => {
    return {
      searchValue: searchValue,
    };
  }
);

export const createShareholding = createAsyncThunk(
  "shareholding/create",
  async ({ shareholding }, thunkAPI) => {
    thunkAPI.dispatch(setLoading(true));
    try {
      const data = await ShareholdingService.createShareholding(shareholding);
      thunkAPI.dispatch(getOshmaById({ id: shareholding?.oshmaId }));
      thunkAPI.dispatch(setLoading(false));
      return thunkAPI.rejectWithValue();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setLoading(false));
      thunkAPI.dispatch(setMessage({ message: message }));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const updateShareholding = createAsyncThunk(
  "shareholding/update",
  async ({ shareholding }, thunkAPI) => {
    thunkAPI.dispatch(setLoading(true));
    try {
      const data = await ShareholdingService.updateShareholding(shareholding);
      thunkAPI.dispatch(getOshmaById({ id: shareholding?.oshmaId }));
      thunkAPI.dispatch(setLoading(false));
      return thunkAPI.rejectWithValue();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setLoading(false));
      thunkAPI.dispatch(setMessage({ message: message }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const deleteShareholding = createAsyncThunk(
  "shareholding/delete",
  async ({ dataDelete }, thunkAPI) => {
    try {
      const data = await ShareholdingService.deleteShareholding(dataDelete?.id);
      thunkAPI.dispatch(setMessage({ message: "Rekordi u fshi me sukses!" }));
      thunkAPI.dispatch(getOshmaById({ id: dataDelete?.oshmaId }));
      return thunkAPI.rejectWithValue();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message }));
      return thunkAPI.rejectWithValue();
    }
  }
);

const shareholdingSlice = createSlice({
  name: "shareholding",
  initialState,
  extraReducers: {
    [setSearch.fulfilled]: (state, action) => {
      state.searchValue = action.payload.searchValue;
    },
    [setSearch.rejected]: (state, action) => {
      state.searchValue = "";
    },
  },
});

const { reducer } = shareholdingSlice;
export default reducer;
